// Mock data for Perfect Electrical Solutions

export const companyInfo = {
  name: "Perfect Electrical Solutions",
  tagline: "Expert Industrial Automation & Electrical Control Solutions",
  logo: "https://5.imimg.com/data5/SELLER/Logo/2024/9/448039600/DN/TH/WV/154305423/logo-png-120x120.png",
  phone: "+91-7489174850",
  email: "perfectelectrical.92@gmail.com",
  whatsapp: "+91-7489174850",
  address: "Sanskar Valley, Sector No. 1, Pithampur, Dhar, Madhya Pradesh - 454775",
  gst: "23DTVPK2579B1ZG",
  yearsOfExperience: 10,
  projectsCompleted: 800,
  clientsServed: 600,
  indiamart: "https://www.indiamart.com/perfect-electrical-solutions/",
  googleBusiness: "#"
};

export const services = [
  {
    id: 1,
    title: "Control Panel Manufacturing",
    description: "Custom-designed control panels including Fire Fighting Panels, APFC Panels, VFD Panels, and Industrial PLC Control Panels. Built with precision for reliable industrial operations.",
    icon: "Cpu",
    image: "https://customer-assets.emergentagent.com/job_power-pro-india/artifacts/qvh0yfrq_image.png",
    industries: ["Manufacturing", "Commercial Buildings", "Industrial Plants"]
  },
  {
    id: 2,
    title: "PLC Programming & Automation",
    description: "Advanced Industrial PLC programming and complete automation solutions. Expert implementation of Delta, Siemens, and other industrial PLCs for seamless operations.",
    icon: "Settings",
    image: "https://images.unsplash.com/photo-1720036236694-d0a231c52563",
    industries: ["Factory Automation", "Process Industries", "Material Handling"]
  },
  {
    id: 3,
    title: "VFD & Drive Services",
    description: "Complete VFD installation, programming, and repair services. Expert troubleshooting and maintenance for all brands of Variable Frequency Drives.",
    icon: "Gauge",
    image: "https://images.unsplash.com/photo-1729944950511-e9c71556cfd4",
    industries: ["Motor Control", "Energy Management", "Industrial Machinery"]
  },
  {
    id: 4,
    title: "HMI Solutions",
    description: "Human Machine Interface installation and programming. Delta HMI, Weintek HMI, and DOP HMI screen solutions for intuitive industrial control.",
    icon: "Monitor",
    image: "https://customer-assets.emergentagent.com/job_power-pro-india/artifacts/g0t495hd_image.png",
    industries: ["Process Control", "Manufacturing", "Automation Systems"]
  },
  {
    id: 5,
    title: "PLC & VFD Repair",
    description: "Professional repair services for PLC, VFD, Servo Drives, and HMI systems. Quick turnaround with genuine parts and expert diagnostics.",
    icon: "Wrench",
    image: "https://images.unsplash.com/photo-1544724569-5f546fd6f2b5",
    industries: ["Industrial Maintenance", "Manufacturing Support", "Emergency Repairs"]
  },
  {
    id: 6,
    title: "Electrical AMC Services",
    description: "Comprehensive Annual Maintenance Contracts for all electrical and automation equipment. Preventive maintenance to ensure zero downtime.",
    icon: "Shield",
    image: "https://customer-assets.emergentagent.com/job_power-pro-india/artifacts/i4jn5l1h_image.png",
    industries: ["Industrial Plants", "Commercial Complexes", "Manufacturing Units"]
  }
];

export const projects = [
  {
    id: 1,
    title: "Fire Fighting Control Panel Installation",
    description: "Three-phase fire fighting control panel with automatic water pump control system for commercial complex.",
    image: "https://5.imimg.com/data5/SELLER/Default/2024/9/450265307/SV/JH/KN/154305423/fire-fighting-panel-250x250.jpg",
    category: "Control Panel",
    client: "Commercial Complex, Indore",
    location: "Indore, MP"
  },
  {
    id: 2,
    title: "Industrial PLC Automation",
    description: "Complete automation solution with Delta PLC programming for packaging machine control system.",
    image: "https://customer-assets.emergentagent.com/job_power-pro-india/artifacts/9bv31n3c_image.png",
    category: "Automation",
    client: "Manufacturing Unit",
    location: "Pithampur, MP"
  },
  {
    id: 3,
    title: "VFD Panel for Cooling Tower",
    description: "Three-phase VFD control panel for energy-efficient cooling tower motor control with temperature sensing.",
    image: "https://customer-assets.emergentagent.com/job_power-pro-india/artifacts/11wbegt6_image.png",
    category: "VFD Systems",
    client: "Industrial Plant",
    location: "Dewas, MP"
  },
  {
    id: 4,
    title: "HMI Screen Integration",
    description: "Delta HMI screen programming and integration with existing PLC system for real-time monitoring.",
    image: "https://images.unsplash.com/photo-1717386255773-a456c611dc4e",
    category: "HMI Solutions",
    client: "Food Processing Unit",
    location: "Indore, MP"
  },
  {
    id: 5,
    title: "APFC Panel Installation",
    description: "Automatic Power Factor Correction panel to reduce electricity bills and improve power quality.",
    image: "https://images.unsplash.com/photo-1759830337357-29c472b6746c",
    category: "Power Management",
    client: "Textile Industry",
    location: "Pithampur, MP"
  },
  {
    id: 6,
    title: "PLC Repair & Upgradation",
    description: "Complete PLC system diagnostics, repair, and firmware upgrade for improved performance.",
    image: "https://customer-assets.emergentagent.com/job_power-pro-india/artifacts/n8k6ot0e_image.png",
    category: "Repair Services",
    client: "Pharmaceutical Company",
    location: "Indore, MP"
  },
  {
    id: 7,
    title: "VFD Drive Repair",
    description: "Expert VFD drive diagnostics and repair with parameter optimization for precise motor control.",
    image: "https://images.unsplash.com/photo-1753964724380-2c5ae02512a8",
    category: "Repair Services",
    client: "CNC Machine Shop",
    location: "Pithampur, MP"
  },
  {
    id: 8,
    title: "Electrical AMC Service",
    description: "Annual maintenance contract covering all electrical panels, PLCs, and automation equipment.",
    image: "https://images.unsplash.com/photo-1584321341057-84aabd4d0399",
    category: "AMC Services",
    client: "Auto Component Manufacturer",
    location: "Pithampur, MP"
  },
  {
    id: 9,
    title: "Motor Control Centre",
    description: "Custom motor control centre design and installation for production line with multiple motor controls.",
    image: "https://images.unsplash.com/photo-1558054665-fbe00cd7d920",
    category: "Motor Control Centre",
    client: "Packaging Industry",
    location: "Dewas, MP"
  },
  {
    id: 10,
    title: "Industrial Control Panel Upgrade",
    description: "Complete control panel modernization with latest safety features and energy-efficient components.",
    image: "https://customer-assets.emergentagent.com/job_power-pro-india/artifacts/vqfhuvj9_image.png",
    category: "Control Panel",
    client: "Chemical Processing Plant",
    location: "Indore, MP"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Sharma",
    company: "ABC Manufacturing Ltd.",
    rating: 5,
    text: "Perfect Electrical Solutions delivered exceptional PLC automation for our production line. Their technical expertise and prompt service helped us achieve 30% efficiency improvement.",
    location: "Indore, MP"
  },
  {
    id: 2,
    name: "Amit Patel",
    company: "Industrial Solutions Pvt. Ltd.",
    rating: 5,
    text: "We faced critical VFD failure and they responded within hours. Expert diagnostics and quality repair work. Highly reliable team for emergency support.",
    location: "Pithampur, MP"
  },
  {
    id: 3,
    name: "Suresh Kumar",
    company: "Tech Manufacturing Co.",
    rating: 5,
    text: "Their control panel quality is outstanding. Clean wiring, proper documentation, and excellent after-sales support. Best electrical service in the region.",
    location: "Dewas, MP"
  },
  {
    id: 4,
    name: "Vikram Singh",
    company: "Auto Components India",
    rating: 5,
    text: "The AMC service has been excellent. Regular preventive maintenance has reduced our downtime significantly. Professional and knowledgeable engineers.",
    location: "Pithampur, MP"
  }
];

export const certifications = [
  {
    id: 1,
    title: "GST Registration",
    number: "23DTVPK2579B1ZG",
    description: "Government registered electrical solutions provider",
    icon: "FileCheck"
  }
];

export const facilityImages = [
  {
    id: 1,
    title: "Manufacturing Unit",
    image: "https://5.imimg.com/data5/SELLER/Default/2024/9/450323541/BV/JB/UA/154305423/ggg-1000x1000.jpg",
    description: "Our well-equipped manufacturing facility"
  },
  {
    id: 2,
    title: "Manufacturing Facilities",
    image: "https://5.imimg.com/data5/SELLER/Default/2024/9/450323903/CY/FX/JT/154305423/ghf-1000x1000.jpg",
    description: "Advanced tools for precision panel assembly"
  },
  {
    id: 3,
    title: "Company Workspace",
    image: "https://5.imimg.com/data5/NSDMERP/Board/2024/9/449891601/UU/DC/EX/154305423/154305423-board-1725984007698-1000x1000.jpg",
    description: "Professional workspace and testing area"
  }
];
